<script setup>
const props = defineProps({
    show_date: {
        type: Boolean,
        required: false,
        default: false,
    },

    businesses: {
        type: Object,
        required: true,
        default: () => [],
    },
})
</script>

<template>
    <article
        v-for="business in businesses"
        :key="business.id"
        class="slower-animation group relative h-[400px] overflow-hidden rounded-xl shadow-md shadow-gray-400 hover:shadow-none xl:h-[500px]"
    >
        <div class="h-[30rem] overflow-hidden">
            <img
                :src="'/storage/businesses/' + business.id + '/thumbnail/' + business.thumbnail"
                :alt="business.title"
                loading="lazy"
                class="slower-animation h-full w-full object-cover object-center group-hover:scale-[1.02]"
            />
        </div>

        <div
            class="absolute bottom-0 left-0 z-10 flex h-full w-full flex-col items-start justify-end space-y-5 bg-gradient-to-t from-gray-100 from-[8%] via-transparent to-transparent p-3 xl:from-[17%] xl:p-5"
        >
            <header>
                <h2 class="font-roboto-slab text-left text-xl leading-8 font-[500] text-gray-800 xl:text-3xl">
                    {{ business.title }}
                </h2>
            </header>

            <footer v-if="show_date">
                <p class="font-roboto-slab text-xs leading-5 font-light tracking-widest text-gray-800">
                    {{ business.published_at }}
                </p>
            </footer>
        </div>

        <Link
            :href="route('businesses.show', business.slug)"
            class="absolute inset-0 z-20"
            :aria-label="'Podnik ' + business.title"
        />
    </article>
</template>
